import PurchaseMileagePage from "./PurchaseMileagePage"

export default PurchaseMileagePage
